import React, { useState } from "react";
import dawswer from "../img/dawswer.png";
import liguepadle from "../img/liguepadel.png";
import muxicsong from "../img/muxicsong.png";
import resume from "../img/resume.png";
import ModalComponent from "./ModalComponent";

const Projects = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    const openModal = (project) => {
        setSelectedProject(project);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedProject(null);
    };

    const projects = [
        {
            title: 'DaWnswer',
            imageSrc: dawswer,
            description: 'La idea propuesta para este proyecto es la de crear un foro donde los usuarios puedan realizar preguntas relacionadas con las asignaturas del curso de DAW, y que estas puedan ser resueltas por otros usuarios que conozcan dichas respuestas.',
            modalDescription: 'a) Laravel, b) MariaDB , c) Multi-Rol, d) Web y API, g) AWS y Docker ',
            modalPlanteamiento: `Realizamos un foro exclusivo para asignaturas de la fromacion profesiona Desarrollo de Aplicaciones Web, Este es accesible para 3 viewers:
            a) un rol usuario que solo puede leer, b) un usuario que puede leer y preguntar,  c) un usuario moderador (administrador).
            Los usuarios registrados podran realizar preguntas, editar y eliminar sus propios posts, ademas podran contestar a preguntas hechas por otros usuarios.
            Los usuarios Administradores podran eliminar y moderar las preguntas, ademas de los hilos de conversacion que tenga dicha pregunta.
            Añadimos una Api para consulta automatica de cursos gratuitos publicados en Lanbide.
            Añadimos tambien una geolocalizacion de las biobliotecas que se encuentran cerca de nuestra posicion.
            para el despliegues, utilizamos los servicios de AWS ademas lo realizamos con Docker.`,
            demoUrl: 'https://demo1.com',
            techStack: ['html5', 'css3', 'js', 'Laravel', 'PHP', 'AWS']
        },
        {
            title: 'Padel Social Ligue',
            imageSrc: liguepadle,
            description: 'La idea propuesta para este proyecto es la de crear el gestor de una competicion en concreto la Liga social de padel de un club, en este gestor podemos añadir jugadore, registrar jornadas y ademas registarr y mostrar resultados.',
            modalDescription: 'a) Java, b) Spring Boot, c) Hibernate y JPA ,c) Spring Security y Multi-Rol, d) Thymeleaft y API, g) AWS y Docker ',
            modalPlanteamiento: 'Realizamos un Gestor de competicion en concreto de una liga de padel para un club, en esta podremos crear los perfiles de los jugadores que competiran, ademas realizar la gestion de la sjornadas y los resultados',
            demoUrl: 'https://demo2.com',
            techStack: ['Java', 'Sass', 'Laravel', 'js', 'database', 'AWS']
        },
        {
            title: 'MuxicOn',
            imageSrc: muxicsong,
            description: 'La idea propuesta para este proyecto es la de crear un foro donde los usuarios puedan realizar preguntas relacionadas con las asignaturas del curso de DAW, y que estas puedan ser resueltas por otros usuarios que conozcan dichas respuestas.',
            modalDescription: '',
            modalPlanteamiento: '',
            demoUrl: 'https://demo3.com',
            techStack: ['html5', 'css3', 'Laravel', 'js', 'PHP', 'AWS']
        },
        {
            title: 'Basic Web Incidencias',
            imageSrc: resume,
            description: 'La idea propuesta para este proyecto es la de crear un foro donde los usuarios puedan realizar preguntas relacionadas con las asignaturas del curso de DAW, y que estas puedan ser resueltas por otros usuarios que conozcan dichas respuestas.',
            modalDescription: 'a) Docker, b) Stack TALL, c) Multi-Rol, d) Web y API y e) Cobertura de tests (90%)',
            modalPlanteamiento: `Un gestor Web de incidencias, protegido con login. Y accesible para 2 roles: 
            a) Administrador: Puede ver/gestionar (CRUD) todas las incidencias y asignarlas a Soporte.
            b) Soporte: Puede ver solo las incidencias asignadas y gestionar su estado (CRUD).
            El ciclo de vida de las licencias solo contempla 3 estados: "To Do", "Doing" y "Done".
            Las licencias generadas por el rol de Soporte se le asignarán directamente.
            Una API (autenticada) permitirá consultar las incidencias, filtradas por su estado. La visibilidad de las licencias tendrá el mismo criterio que en Web (Administrador vs Soporte).
            La solución incluirá tests con una cobertura mínima del 90% sobre el código generado.
            Se valorará la definición de la infraestructura en entorno Docker (Nginx + PHP).`,
            demoUrl: 'https://demo4.com',
            techStack: ['html5', 'css3', 'Laravel', 'js', 'PHP', 'AWS']
        }
    ];

    return (
        <section className="project" id="porfolio">
            <div className="title">
                <h3>Portfolio</h3>
            </div>
            <div className="listApp">
                {projects.map((project, index) => (
                    <article key={index}>
                        <h3>{project.title}</h3>
                        <figure>
                            <img src={project.imageSrc} alt={project.title} />
                        </figure>
                        <div className="project-description">
                            <p>{project.description}</p>
                        </div>
                        <div className="tech-stack">
                            <strong>Stack Tecnológico:</strong>
                            <ul>
                                {project.techStack.map((tech, idx) => (
                                    <li key={idx}><i className={`fa-brands fa-${tech.toLowerCase()}`}></i></li>
                                ))}
                            </ul>
                        </div>
                        <div className="action-buttons">
                            <a className="btn" onClick={() => openModal(project)}>Ver Proyecto</a>
                            <a className="btn" href={project.demoUrl} target="_blank" rel="noopener noreferrer">Ver Demo</a>
                        </div>
                    </article>
                ))}
            </div>
            {selectedProject && (
                <ModalComponent
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    title={selectedProject.title}
                    modalDescription={selectedProject.modalDescription}
                    modalPlanteamiento={selectedProject.modalPlanteamiento}
                />
            )}
        </section>
    );
};

export default Projects;